import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dropdown relative inline-block" }
const _hoisted_2 = { class: "mr-4 mt-4 flex items-center lg:mr-10" }
const _hoisted_3 = {
  key: 0,
  class: "top-20 right-5 hidden lg:absolute lg:z-10 lg:block lg:min-w-max lg:rounded lg:bg-[#570df8] lg:px-3 lg:py-2 lg:font-normal lg:text-white"
}
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = {
  key: 1,
  class: "absolute -right-5 z-50 mt-2 max-w-[240px] overflow-hidden rounded-lg bg-white shadow-sm shadow-black xs:max-w-fit"
}
const _hoisted_6 = {
  tabindex: "0",
  class: "menu max-w-[90vw] rounded p-2 shadow shadow-gray-700 lg:w-[12vw]"
}
const _hoisted_7 = {
  key: 0,
  class: "flex p-3 hover:bg-white lg:hidden"
}
const _hoisted_8 = { class: "text-normal ml-3 flex-col items-baseline truncate p-1 font-medium hover:bg-white xs:text-xl" }
const _hoisted_9 = { class: "truncate text-xs font-normal text-gray-600 xs:text-base" }
const _hoisted_10 = { class: "rounded hover:delay-100" }

import {
  startCase,
} from 'lodash';
import {
  computed,
  ref,
} from 'vue';
import {
  useRouter,
} from 'vue-router';
import ProfileImageAvatar from '@/components/Helper/ProfileImageAvatar.vue';
import HeaderTextLinkButton, {
  HeaderTextLink,
} from '@/components/NavBar/HeaderTextLinkButton.vue';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberMenu',
  props: {
  congested: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const router = useRouter();
const authStore = useStore.auth;



const showName = ref(false);
const isMemberMenuOpen = ref(false);

const user = computed(() => authStore.user);
const name = computed(() => {
  if (!user.value) {
    return '';
  }
  return startCase(`${user.value.firstName} ${user.value.lastName || ''}`);
});

const MEMBER_TEXT_LINKS: HeaderTextLink[] = [
  {
    name: 'Account', route: '/user/account',
  },
];

const availableTextLinks = computed(() => MEMBER_TEXT_LINKS
  .filter((l) => !l.hidden && user));

async function logout(): Promise<void> {
  authStore.logout();
  if (router.currentRoute.value.path !== '/') {
    await router.push('/');
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (showName.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(name)), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "h-11 w-11 rounded-full",
          onMouseover: _cache[0] || (_cache[0] = ($event: any) => (showName.value = !showName.value)),
          onFocus: _cache[1] || (_cache[1] = ($event: any) => (showName.value = !showName.value)),
          onMouseout: _cache[2] || (_cache[2] = ($event: any) => (showName.value = !showName.value)),
          onBlur: _cache[3] || (_cache[3] = ($event: any) => (showName.value = !showName.value)),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (isMemberMenuOpen.value = !isMemberMenuOpen.value))
        }, [
          (_unref(user))
            ? (_openBlock(), _createBlock(ProfileImageAvatar, {
                key: 0,
                user: _unref(user),
                size: 44
              }, null, 8, ["user"]))
            : _createCommentVNode("", true)
        ], 32),
        (isMemberMenuOpen.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              tabindex: "-1",
              class: "fixed inset-0 top-0 z-50 h-full w-full cursor-default bg-gray-500 opacity-20",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (isMemberMenuOpen.value = false))
            }))
          : _createCommentVNode("", true),
        (isMemberMenuOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("ul", _hoisted_6, [
                (_unref(user))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createVNode(ProfileImageAvatar, {
                        user: _unref(user),
                        size: 50
                      }, null, 8, ["user"]),
                      _createElementVNode("div", _hoisted_8, [
                        _createTextVNode(_toDisplayString(_unref(name)) + " ", 1),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(user).username), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableTextLinks), (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `${item.name}_${index}`,
                    class: "py-1",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (isMemberMenuOpen.value = false)),
                    onKeypress: _cache[7] || (_cache[7] = ($event: any) => (isMemberMenuOpen.value = false))
                  }, [
                    _createVNode(HeaderTextLinkButton, {
                      name: item.name,
                      route: item.route,
                      url: item.url,
                      event: item.event,
                      block: ""
                    }, null, 8, ["name", "route", "url", "event"])
                  ], 32))
                }), 128)),
                _createElementVNode("li", _hoisted_10, [
                  _createVNode(HeaderTextLinkButton, {
                    name: "Sign out",
                    block: "",
                    onClick: logout
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})